import { useMatches } from 'react-router';

export function useCombinedRouterMatchesHandle<TProps>(
  handleProps?: TProps,
): TProps {
  const matches = useMatches();

  const combinedProps: Record<string, unknown> = { ...handleProps };

  for (const match of matches) {
    const matchHandle = match.handle ?? {};

    const matchLoaderDataHandle =
      match.loaderData &&
      typeof match.loaderData === 'object' &&
      'handle' in match.loaderData &&
      typeof match.loaderData.handle === 'object'
        ? match.loaderData.handle
        : {};

    Object.assign(combinedProps, matchHandle, matchLoaderDataHandle);
  }

  return combinedProps as TProps;
}
